import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { formatDimensionName, getScoreColor, getScoreBgColor, getScoreLabel } from '../../utils/scoreHelpers';

export default function DimensionDetail({ scores }) {
  return (
    <div className="card">
      <h2 className="text-lg font-semibold mb-4">Dimensional Breakdown</h2>
      <div className="space-y-3">
        {Object.entries(scores).map(([key, val]) => (
          <DimensionRow key={key} name={key} data={val} />
        ))}
      </div>
    </div>
  );
}

function DimensionRow({ name, data }) {
  const [expanded, setExpanded] = useState(false);
  const score = typeof data === 'object' ? data.score : data;
  const feedback = typeof data === 'object' ? data.feedback : '';
  const label = typeof data === 'object' && data.label ? data.label : getScoreLabel(score);

  return (
    <div>
      <button
        onClick={() => feedback && setExpanded(!expanded)}
        className="w-full text-left"
      >
        <div className="flex items-center justify-between mb-1">
          <span className="text-bastion-gray-700 font-medium text-sm">
            {formatDimensionName(name)}
          </span>
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-bastion-gray-700">{label}</span>
            <span className={`font-bold text-sm ${getScoreColor(score)}`}>{score}</span>
            {feedback && (
              <ChevronDown className={`w-4 h-4 text-bastion-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`} />
            )}
          </div>
        </div>
        <div className="h-2.5 bg-bastion-gray-200 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-700 ease-out ${getScoreBgColor(score)}`}
            style={{ width: `${score}%` }}
          />
        </div>
      </button>
      {expanded && feedback && (
        <p className="mt-2 text-sm text-bastion-gray-800 pl-1 border-l-2 border-bastion-gray-300 ml-1 py-1 pl-3">
          {feedback}
        </p>
      )}
    </div>
  );
}
